import Escalatedcomplaintsview from "../../../jsx/components/Dashboard/EscalatedComplaints/escalatedcomplaintsview";

const EscalatedComplaintsViewWrapper = () => {
  return <Escalatedcomplaintsview />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.grievance_staff, _enum.ROUTE_PERSONAS.nodal_officer];
export default constore(EscalatedComplaintsViewWrapper);
